import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    intervideoRatings: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_INTERVIDEORATING_SELECT_IDS (store, ids) {
      store.intervideoRatings.selectIds = ids
    },
    REMOVE_INTERVIDEORATING_SELECT_IDS (store, ids) {
      store.intervideoRatings.selectIds = store.intervideoRatings.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_INTERVIDEORATING_SELECT_ID (store, id) {
      store.intervideoRatings.selectId = id
    },
    SET_INTERVIDEORATING_FILTERS (store, filters) {
      store.intervideoRatings.filters = filters
    },
    SET_INTERVIDEORATING_PAGINATE (store, val) {
      store.intervideoRatings.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getIntervideoRatings: (store, getters) => {
      return store.intervideoRatings.selectIds.map((id) => {
        return getters['entities/intervideoRatings/find'](id)
      })
    },
    getIntervideoRatingsFilters: (store, getters) => {
      return store.intervideoRatings.filters
    },
    getIntervideoRatingsPaginate: (store, getters) => {
      return store.intervideoRatings.paginate
    },
    getIntervideoRating: (store, getters) => {
      return getters['entities/intervideoRatings/find'](store.intervideoRatings.selectId) || {}
    }
  },
  actions: {
    /*
    selectIntervideoRatings
    */
    selectIntervideoRatings ({commit, dispatch, getters, state}, filters) {
      return dispatch('getIntervideoRatings', filters)
      .then((response) => {
        commit('SET_INTERVIDEORATING_FILTERS', filters)
        commit('SET_INTERVIDEORATING_PAGINATE', response)
        commit('SET_INTERVIDEORATING_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectIntervideoRatings
    */
    refreshSelectIntervideoRatings ({commit, dispatch, getters, state}) {
      return dispatch('selectIntervideoRatings', getters.getIntervideoRatingsFilters)
    },
    /*
    selectIntervideoRating
    */
    selectIntervideoRating ({commit, dispatch, getters, state}, id) {
      return dispatch('getIntervideoRatingById', id)
      .then((response) => {
        commit('SET_INTERVIDEORATING_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getIntervideoRatings
    */
    getIntervideoRatings ({commit, dispatch, getters, state}, filters) {
      let intervideoId = filters.intervideo_id
      delete filters.intervideo_id

      return axios
      .get(`/accounts/${getters.getAccount._id}/intervideos/${intervideoId}/ratings`, {params: filters})
      .then((response) => {
        return dispatch('entities/intervideoRatings/insert', {
          data: response.data
        })
        .then((result) => {
          return result.intervideoRatings || []
        })
      })
    },
    /*
    getIntervideoRatingById
    */
    getIntervideoRatingById ({commit, dispatch, getters, state}, data) {
      let intervideoId = data.intervideo_id
      delete data.intervideo_id

      return axios
      .get(`/accounts/${getters.getAccount._id}/intervideos/${intervideoId}/ratings/${data._id}`)
      .then((response) => {
        return dispatch('entities/intervideoRatings/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.intervideoRatings[0]
      })
    },
    /*
    createIntervideoRating
    */
    createIntervideoRating ({commit, dispatch, getters, state}, data) {
      delete data.$id

      let intervideoId = data.intervideo_id
      delete data.intervideo_id

      return axios
      .post(`/accounts/${getters.getAccount._id}/intervideos/${intervideoId}/ratings`, data)
      .then((response) => {
        return dispatch('entities/intervideoRatings/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.intervideoRatings[0]
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/IntervideoRating.js